import classNames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import { PriceSidePanelStatus } from 'components/shared/Price/shared';
import type { IntlKey } from 'locales';
import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';

interface StatusLabelProps {
  children?: ReactNode;
  labelKey: IntlKey;
  color: 'info' | 'secondary' | 'success';
}

function Message({ labelKey, color }: Pick<StatusLabelProps, 'labelKey' | 'color'>) {
  const { formatMessage } = useIntl();
  return (
    <div className={classNames('d-flex', `text-${color}`)} title={formatMessage({ id: 'sidePanel.status.title' })}>
      <em className="icon icon-sm pe-2">offline_bolt</em>
      <FormattedMessage id={labelKey} />
    </div>
  );
}

export const StatusLabel: FC<StatusLabelProps> = ({ labelKey, color, children }) => {
  return (
    <PriceSidePanelStatus
      color="primary"
      topLeft={<Message color={color} labelKey={labelKey} />}
      topRightActions={children}
    />
  );
};

StatusLabel.displayName = 'StatusLabel';
